module.exports = __webpack_public_path__ + "static/media/5.5 Inch IPhone 6s_1.92bc68d4.png";